import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
    selector: '[nsPinElement]'
})

/**
 * Dyrektywa '[nsPinElement]' powinna być przypięta do kontenera elementu, który ma pływać.
 * Element który ma pływać powinien mieć dodaną klasę '.pin-element'.
 * Wyłapywany jest event scrolla na elemencie '.content' i podczas niego jest modyfikowana pozycja przypiętego elementu.
 * @Input() top - przesunięcie elementu w dół względem początkowej pozycji
 * @Input() bottom - przesunięcie elementu do góry względem początkowej pozycji
 * @Input() topMarginBuffer - wartość o ile wcześniej ma się zacząć przesuwać elment wzlędem górenej krawędzi ekranu
 */
export class PinElementDirective implements AfterViewInit, OnDestroy {
    private sub: Subscription = new Subscription();
    private topPosition = 0;
    private scrollTopPosition = 0;
    private bottomLimit = 0;
    private scrollingElement;
    private elementHeight;
    @Input() elementToScroll = '.pin-element';
    @Input() top = 0;
    @Input() bottom = 0;
    @Input() topMarginBuffer = 0;
    private offsetBottom;


    constructor(private el: ElementRef) {
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.scrollingElement = this.el.nativeElement.querySelector(this.elementToScroll);
        if (!this.scrollingElement) {
            return;
        }
        this.scrollingElement.style.width = this.scrollingElement.clientWidth + 'px';
        this.topPosition = this.getCoords(this.el.nativeElement);
        this.scrollTopPosition = this.getCoords(this.scrollingElement);

        this.scrollingElement.style.position = 'absolute';
        this.el.nativeElement.style.overflow = 'hidden';

        this.el.nativeElement.style.position = 'relative';

        this.elementHeight = this.scrollingElement.clientHeight;
        this.offsetBottom = this.bottom + this.scrollingElement.clientHeight + (this.scrollTopPosition - this.topPosition);
        this.bottomLimit = this.el.nativeElement.clientHeight - this.offsetBottom;
        this.sub.add(fromEvent(document.body.querySelector('.content'), 'scroll').subscribe((value) => this.onScroll(value)));
        this.sub.add(fromEvent(window, 'resize').subscribe(() => this.onResize()));
    }

    // cross browser version
    private getCoords(elem) {
        const box = elem.getBoundingClientRect();

        const body = document.body;
        const docEl = document.documentElement;

        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

        const clientTop = docEl.clientTop || body.clientTop || 0;

        const top = box.top + scrollTop - clientTop;

        return Math.round(top);
    }

    private onScroll(event) {
        const el = this.scrollingElement;
        const documentTop = event.target.scrollTop + this.top;
        const positionTop = documentTop - this.scrollTopPosition + Number(this.topMarginBuffer);
        this.bottomLimit = this.el.nativeElement.clientHeight - this.offsetBottom;
        if (positionTop >= 0) {
            if (positionTop < this.bottomLimit) {
                el.style.position = 'fixed';
                el.style.top = Number(this.topMarginBuffer) + this.top + 'px';
            } else {
                el.style.position = 'absolute';
                el.style.top = this.bottomLimit + 'px';
            }
        } else {
            el.style.top = 'initial';
            el.style.position = 'relative';
        }
    }

    private onResize() {
        this.scrollingElement.classList.remove('pinned');
        this.scrollingElement.classList.add('pin-top');

    }
}
